module.exports = __webpack_public_path__ + "static/media/delivery.f098963f.svg";